import React, { useEffect, useRef } from "react"

import { publicClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"

const isEventScheduled = e =>
  e.origin === "https://calendly.com" &&
  e.data?.event === "calendly.event_scheduled"

const CalendlyWidget = ({ token }) => {
  const listener = useRef()
  const [, runMutation] = useMutation(saveInterviewMutation, client)

  useEffect(() => {
    const script = document.createElement("script")

    script.src = "https://assets.calendly.com/assets/external/widget.js"
    script.async = true

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  })

  useEffect(() => {
    listener.current = window.addEventListener("message", function (e) {
      if (isEventScheduled(e)) {
        runMutation({
          token,
          eventUri: e.data.payload.event.uri,
        })
      }
    })

    return () => {
      window.removeEventListener(listener.current)
    }
  }, [runMutation, token])

  return (
    <div
      className="calendly-inline-widget h-[630px] min-w-[320px]"
      data-url={process.env.TUTOR_APPLICATION_INTERVIEW_CALENDLY_URL}
    />
  )
}

const saveInterviewMutation = gql`
  mutation ($token: String!, $eventUri: String!) {
    tutorApplicationInterviewScheduled(token: $token, eventUri: $eventUri) {
      failures {
        message
      }
    }
  }
`

export default CalendlyWidget
